import React, { useState } from 'react';
import Navbar from './Components/Navbar';
import Homepage from './Components/Homepage';
import ResumeBuilder from './Components/Resume_builder';
import EditTemplate from './Components/EditTemplate';
import AIScreening from './Components/AIScreening';
import RequireAuth from './Components/RequireAuth';
import Login from './Components/Login';
import ChatGbt from './Components/ChatGbt';


import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';




const App = () => {
  const [showResumeBuilder,setshowResumeBuilder]=useState(false);
  const [showTemplate,setshowTemplate]=useState(false);

   
  return (
    <>
    
    
    <Router>
      <Navbar />
      <Routes>
        <Route path="/ai-screening" element={<AIScreening />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/ChatGbt" element={<ChatGbt />} />
      
      
     
       
        <Route path="/" element={!showResumeBuilder ? 
            (<Homepage onCreateResume={()=> setshowResumeBuilder(true) } />) : 
        !showTemplate ?
            (<ResumeBuilder onEdit={()=> setshowTemplate(true) } />) : 
        (<EditTemplate  element={
          <>
              <RequireAuth>
              <EditTemplate />
              </RequireAuth>
          </>
        } />)
        }
        />

       
       


        <Route path="/edit-template" element={
          <>
              <RequireAuth>
              <ResumeBuilder />
              </RequireAuth>
          </>
        } />

        
      </Routes>
    </Router>
    
  
    
    </>
  );
};

export default App;